<template>
  <div>
    <template v-if="api_errors.length > 0">
        <div class="mb-2" v-for="error in api_errors" :key="error.message">
            <vs-alert color="danger" icon="new_releases">
            <small>{{error}}</small>
            </vs-alert>
        </div>
    </template>

    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="getList"
      :max-suggestions="10"
      :min-length="1"
      :debounce="200"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27, 35]
      }"
      :mode="mode"
      :nullable-select="true"
      ref="suggestComponent"
      v-bind:placeholder="$t('addressBook.searchAddress')"
      value-attribute="address"
      display-attribute="address"
      @select="onSuggestSelect">

       <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>{{$t('addressBook.searching', [query])}}.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <div class="misc-item">
            <span>{{$t('addressBook.suggestionShown', [suggestions.length])}}...</span>
          </div>
          <hr>
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>{{$t('general.notAvailable', {msg: capitalizeFirstLetter($t('attribute.address'))})}}</span>
        </div>
      </template>

      <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
          <p v-html="boldenSuggestion(scope)"></p>
      </div>

      <div class="misc-item" slot="misc-item-below" v-if="loading">
        <span>{{capitalizeFirstLetter($t('action.loading'))}}...</span>
      </div>
    </vue-simple-suggest>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import ErrorHandler from '@/helper/error_handler'

export default {
  name: 'address-auto-complete',
  props:['value', 'delivery_type'],
  data() {
    return {
      model: this.value,
      mode: 'input',
      loading: false,
      api_errors: []
    }
  },
  components: {
    VueSimpleSuggest
  },
  methods: {
    async getList (inputValue) {
        let result = []
        let url = this.$endpoints.customer_search_address + '?keyword=' + inputValue
        this.loading = true

        result = await this.$http.get(url).then((response) => {
          this.loading = false
          result = response.data.data
          result = result.filter(function(part, i) {
            return part.postal !== 'NIL' ? true : false
          })
          return result
        }).catch((error) => {
          this.loading = false
          reject(error)
        })

        return result
    },
    onSuggestSelect (suggest) {
      this.$vs.loading({
        type: 'radius',
        text: this.$t('addressBook.checkLocation') + '...'
      })

      this.selected = suggest

      this.checkForbidden(suggest.postal)
      .then(res => {
        this.$emit('onSelectSuggestion', suggest);
        this.$vs.loading.close()
        this.api_errors = []
      })
      .catch(err => {
        this.$vs.loading.close()
        this.model = null
        this.api_errors = ErrorHandler.processErrorMessage(err)

        this.$vs.notify({
            time: 3000,
            color:'danger',
            title:'Viamove System',
            text:this.api_errors[0],
        })
      })

    },
    checkForbidden(postal){
      return new Promise((resolve, reject) => {
        let url = this.$endpoints.customer_check_forbidden;
        let param = {
          postal_code: postal,
          delivery_type: this.delivery_type,
        };

        this.$http.post(url, param)
        .then(res => {
          resolve(true)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
      if(result.length){
        return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)','gi'), '$1<b>$2</b>$3');
      }
    },
  }
}
</script>
